export enum NavPage {
  HOME = 'home',
  DASHBOARDS = 'dashboards',
  INSIGHTS = 'insights',
  STRATEGY = 'strategy',
  REQUESTS = 'requests',
  PROGRAMS = 'programs',
  PROJECTS = 'projects',
  TASKS = 'tasks',
  SCHEDULE = 'schedule',
  DESIGN = 'design',
  EVALUATIONS = 'evaluations',
  TEAMS = 'teams',
  BUDGET = 'budget',
  SETTINGS = 'settings',
}

export interface NavItem {
  page: NavPage;
  canShow: boolean;
}
